import { SVGProps } from 'react';

const SvgDeviceMobile = (props: SVGProps<SVGSVGElement>) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.75 5H16.25M15 21.25V21.2625M7.5 6.25C7.5 5.58696 7.76339 4.95107 8.23223 4.48223C8.70107 4.01339 9.33696 3.75 10 3.75H20C20.663 3.75 21.2989 4.01339 21.7678 4.48223C22.2366 4.95107 22.5 5.58696 22.5 6.25V23.75C22.5 24.413 22.2366 25.0489 21.7678 25.5178C21.2989 25.9866 20.663 26.25 20 26.25H10C9.33696 26.25 8.70107 25.9866 8.23223 25.5178C7.76339 25.0489 7.5 24.413 7.5 23.75V6.25Z"
      stroke="#2196F3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgDeviceMobile;
